import { BaseEntity, JsonApiProperty, JsonApiResource } from '../jsonapi-provider';

@JsonApiResource({
  type: 'measure',
})
export default class Measure extends BaseEntity {
  @JsonApiProperty({ type: 'string' })
  public reportingUnit: string | null;

  @JsonApiProperty({ resolver: Number })
  public reportingUnitMultiplier: number | null;

  public constructor(
    id?: string,
    public name: string = '',
    reportingUnit?: string,
    reportingUnitMultiplier?: number
  ) {
    super();
    this.id = id;
    this.reportingUnit = reportingUnit ?? null;
    this.reportingUnitMultiplier = reportingUnitMultiplier ?? null;
  }
}
